/**
 * @file Benchmarking tool tabs toggle
 * 
 * @author Konrad Kaliszewski <kkaliszewski@squiz.pl>
 * @date April 2018
 */

var BenchmarkTabsToggle = (function () {
    var colToggle = $('.benchmark-tab__toggle');

    // Toggles quick search form 
    function toggleAriaExpanded() {
        var $toggledEl = $(event.target);
        if (!$toggledEl.hasClass('benchmark-tab__toggle')) {
            $toggledEl = $toggledEl.parent();
        }
        var ariaExpanded = $toggledEl.attr('aria-expanded');
        var expanded;
        switch (ariaExpanded) {
            case "true": {
                expanded = true;
                break;
            }
            case "false": {
                expanded = false;
                break;
            }
            default: {
                break;
            }
        }
        
        $toggledEl.attr('aria-expanded', !expanded);
    }

    // Binds all the events
    function bind() {
        colToggle.click(function() {
            toggleAriaExpanded();
        });
    }

    /**
     * Initialisation
     */
    return {
         init: function() {
            bind();
        }
    }
})();

(function() {
    BenchmarkTabsToggle.init();
}(jQuery));


